<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
            :ref="'grupoCrud'"
            crudName="Grupos"
            newText="Novo Grupo"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :extra="extra"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :enableReset="false"
            :dataForm="dataForm"
            @deleted="onGroupDeleted"
            @updated="onGroupUpdated"
            @created="onGroupCreated"
            @view="onViewItems"
            @view-top="onViewTop"
        >
        </base-crud>
        <grupo-view ref="grupoView"/>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import GrupoView from './View';

export default {
  components: {
    BaseCrud,
    GrupoView,
  },
  data() {
    return {
      unidades: [],
      paineis: [],
      totens: [],
      table: "grupoTable",
      columns: ["nome", "descricao", "status", "actions"],
      tableData: ["nome", "descricao", "status"],
      extra: [{
        id: 'view-top',
        name: 'view-top',
        title: 'Pré-visualizar',
        class: 'btn btn-sm btn-primary btn-view-grupo',
        icon: 'fas fa-eye',
        label: ''
      }],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["nome", "descricao", "status"],
        pagination: {chunk: 10, dropdown: false, nav: "scroll"},
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          nome: "Nome",
          descricao: "Descrição",
          itens_count: "Itens",
          status: "Status",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          unidade_id: [],
          painel_id: [],
          totem_id: [],
          status: [
            {id: 1, text: "Ativo"},
            {id: 0, text: "Inativo"},
          ],
        },
        templates: {
          status: (h, row) => {
            const isActive = row.status === true || row.status === 1 || row.status === "true";
            return h('span', {class: isActive ? 'badge badge-success' : 'badge badge-secondary'}, isActive ? 'Ativo' : 'Inativo');
          },
        },
        requestFunction(data) {
          const query = this.$parent.$parent.$parent.query(data.query);
          const requestData = {params: {...data, query: ""}};
          return this.$http.get(`${this.url}?orderByDesc=id&${query}`, requestData).catch(e => this.dispatch("error", e));
        },
      },
      endPoint: "grupos/",
      dataForm: {},
    };
  },
  methods: {
    query(query) {
      const columns = {nome: "nome", descricao: "descricao", status: "status"};
      let filters = "";
      $.each(query, (index, value) => {
        if (columns[index]) filters += `${columns[index]}=${value}&`;
      });
      return filters;
    },

    refreshTable() {
      if (this.$refs.grupoCrud?.refresh) return this.$refs.grupoCrud.refresh();
      if (this.$refs.grupoCrud?.$refs?.vuetable) return this.$refs.grupoCrud.$refs.vuetable.refresh();
      this.$nextTick(() => window.location.reload());
    },

    onGroupDeleted(deletedItem) {
      this.$message("Sucesso", "Grupo excluído com sucesso", "success");
      setTimeout(() => this.refreshTable(), 100);
    },

    onGroupUpdated() {
      this.refreshTable();
    },
    onGroupCreated() {
      this.refreshTable();
    },

    onViewItems(payload) {
      this.openView(payload.row.id);
    },
    onViewTop(payload) {
      this.openView(payload.row.id);
    },

    openView(id) {
      if (this.$refs.grupoView?.open) return this.$refs.grupoView.open(id);
      this.$router.push({path: `${this.endPoint}view/${id}`});
    },

    getUnidades() {
      const api = `${this.$store.state.api}unidades`;
      axios.get(api)
          .then(response => {
            this.unidades = (response.data.data || []).map(u => ({id: u.id, text: u.nome}));
            this.options.listColumns.unidade_id = this.unidades;
          })
          .catch(error => this.$message && this.$message("Erro", "Erro ao carregar unidades", "error"));
    },

    getPaineis() {
      const api = `${this.$store.state.api}paineis`;
      axios.get(api)
          .then(response => {
            this.paineis = (response.data.data || []).map(p => ({id: p.id, text: p.nome}));
            this.options.listColumns.painel_id = this.paineis;
          })
          .catch(() => this.$message && this.$message("Erro", "Erro ao carregar painéis", "error"));
    },

    getTotens() {
      const api = `${this.$store.state.api}totens`;
      axios.get(api)
          .then(response => {
            this.totens = (response.data.data || []).map(t => ({id: t.id, text: t.nome}));
            this.options.listColumns.totem_id = this.totens;
          })
          .catch(() => this.$message && this.$message("Erro", "Erro ao carregar totens", "error"));
    },
  },

  mounted() {
    this.getUnidades();
    this.getPaineis();
    this.getTotens();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.video-preview-container {
  max-width: 220px;
}

.video-filename {
  color: #2c3e50;
  font-size: 13px;
  display: block;
  margin-bottom: 8px;
  word-break: break-word;
}

.video-preview video {
  max-width: 100%;
  height: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.no-video {
  min-width: 200px;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.no-video i {
  font-size: 24px;
  margin-bottom: 8px;
  opacity: 0.5;
}

@media (max-width: 768px) {
  .video-preview-container {
    max-width: 150px;
  }

  .video-preview video {
    width: 150px;
    height: 90px;
  }

  .no-video {
    min-width: 150px;
    min-height: 90px;
  }
}
</style>

<style>
.btn-view-grupo {
  min-width: 25px !important;
  max-width: 25px !important;
  width: 25px !important;
  min-height: 25px !important;
  max-height: 25px !important;
  height: 25px !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 11px !important;
  line-height: 1 !important;
  border-radius: 4px !important;
}

.btn-view-grupo i {
  margin: 0 !important;
}
</style>
